import ru from '../JsonLang/ru.json'
export const lang = { ...ru }